"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.branch.list': 'Ramas',
    'route.branch.create': 'Agregar Rama',
    'route.branch.edit': 'Editar Rama',
};
